import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/projects/$projectId/hiring/openings',
      params: { projectId: params.projectId },
      replace: true,
    });
  },
});
